import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useInputGroupContext } from '../InputGroup/index.js';
import { Text } from '../Text/index.js';

/**
 * InputErrorMessage is used with InputGroup to display an
 * error message to an associated form control.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/input-group#usage)
 * <br />
 *
 */
const InputErrorMessage = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref;
  const formControl = useInputGroupContext();
  if (!formControl.isInvalid) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Text, _extends({
    ref: forwardedRef,
    as: "p",
    color: "watermelon500",
    mt: "space20",
    size: "fontSize10"
  }, rest), children);
});
InputErrorMessage.displayName = 'InputErrorMessage';

export { InputErrorMessage };
